import { locationPaths, useApi, type LocationDetail } from '@lib/api';
import type { PickedLocation } from '@features/locations/ui/LocationPicker';

/**
 * The location a list is filtered by (`?location=12`, also from a link) with its name for the picker: read by id
 * only while one is set. While its name loads, the picker shows the id.
 */
export function usePickedLocation(id: number | null): PickedLocation | null {
  const found = useApi<LocationDetail>(id ? locationPaths.detail(id) : null);
  if (!id) return null;
  return { id, name: found.data?.id === id ? found.data.name : `#${id}` };
}
